import Vue from 'vue';
import store from './../../store';
import billStatusTransformer from './../../transformers/billStatus';

const success = ({ data }, resolve) => {
  const billStatuses = billStatusTransformer.fetchCollection(data.data);

  store.dispatch('fetchBillStatuses', billStatuses);
  resolve();
};

const failed = () => {
};

// Display bill statuses.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('bill_status')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billStatus/all.js